import { tss } from 'tss-react/mui';

const useStyles = tss.create(({ theme }) => ({
  assetMappingUploadDialogDownloadSection: {
    backgroundColor: theme.vars.palette.background.elevation1,
    border: `1px solid ${theme.vars.palette.divider}`,
    borderRadius: 5,
    padding: '1rem'
  },
  assetMappingUploadDialogIconButtonCancel: {
    height: '2rem',
    position: 'absolute',
    right: 8,
    top: 8,
    width: '2rem'
  },
  assetMappingUploadDialogLinkButton: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    font: 'inherit',
    minWidth: 0,
    padding: 0,
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline'
    }
  }
}));

export default useStyles;
